import React from "react";
//
import Icon from "./Icon";

export default function Score({ value }) {
  return (
    <span>
      {value.toFixed(1)} <Icon name="star" />
    </span>
  );
}
